import { CreditCard, Accessibility, Ticket, Wallet } from "lucide-react";
import { Reveal, ChapterHead } from "./Reveal";

const PAYMENTS = [
  {
    icon: CreditCard,
    title: "Cabcharge",
    text: "Cabcharge cards, Cabcharge Fixe and Cabcharge vouchers — ride now, your account takes care of it. Standard for corporate and government riders.",
    testid: "payment-card-cabcharge",
  },
  {
    icon: Accessibility,
    title: "TTSS e-tickets",
    text: "On the Taxi Transport Subsidy Scheme? Your TTSS e-ticket card is welcome — the subsidy is applied to the metered fare on the spot, no paperwork for you.",
    testid: "payment-card-ttss",
  },
  {
    icon: Ticket,
    title: "Taxi Vouchers",
    text: "Paper taxi vouchers from employers, pubs, clubs, venues or events? Hand it to the driver like cash — we handle the rest.",
    testid: "payment-card-vouchers",
  },
  {
    icon: Wallet,
    title: "Transport Cards & Tap-to-Pay",
    text: "Transport cards, debit, credit and contactless — whatever is in your wallet, the trip works. No cab, no card, no worries.",
    testid: "payment-card-transport",
  },
];

export const Payments = () => (
  <section id="payments" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <ChapterHead
        num="CHAPTER 05"
        kicker="Pay your way"
        title="Cabcharge, TTSS e-tickets and taxi vouchers — accepted on every ride"
      />
      <Reveal delay={0.08}>
        <p className="text-[#99A1B3] max-w-2xl mb-12 -mt-6">
          Searching for a taxi car that takes your transport card or subsidy? Every cab in the
          fleet takes the lot — book a taxi now and pay however suits you.
        </p>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PAYMENTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.07}>
            <article
              data-testid={p.testid}
              className="group h-full bg-ink-800 border border-gold-400/10 rounded-2xl p-7 transition-all duration-300 hover:border-gold-400/40 hover:-translate-y-1"
            >
              <p.icon size={24} className="text-gold-400 mb-5" strokeWidth={1.6} />
              <h3 className="font-display text-lg font-bold text-white mb-3">{p.title}</h3>
              <p className="text-sm leading-relaxed text-[#99A1B3]">{p.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.3}>
        <p className="mt-8 text-xs text-[#626B7F]">
          TTSS subsidies are applied per Transport for NSW rules. Cash, Cabcharge and all major
          cards accepted. Receipts available for every trip.
        </p>
      </Reveal>
    </div>
  </section>
);
